<template>
  <div class="login">
    <v-container>
      <v-layout>
        <v-flex>
          <!-- <div style="padding-top: 10px;padding-bottom: 10px;">
            <h2>
              <strong>Myamax Login</strong>
            </h2>
          </div>-->
          <v-card style="max-width:500px;margin: 0 auto;">
            <v-card-title
              class="headline lighten-2"
              style="padding-top: 10px;padding-bottom: 10px;"
            >
              <h3>
                <strong>Myamax Login</strong>
              </h3>
            </v-card-title>
            <v-card-text style="padding:10px;">
              <v-container
                grid-list-md
                style="padding-top: 0px;padding-bottom: 0px;"
              >
                <v-layout wrap>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">User Name</h4>
                    <v-text-field
                      v-model="uName"
                      class="form-control"
                      v-on:keyup.enter="checkUserInput"
                      name="uName"
                      required
                      outlined
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Password</h4>
                    <v-text-field
                      v-model="uPswd"
                      class="form-control"
                      required
                      v-on:keyup.enter="checkUserInput"
                      outlined
                      type="password"
                      name="uPswd"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <div style="text-align: center;">
                <v-btn class="primary loginBtn" @click="checkUserInput()"
                  >Login</v-btn
                >
              </div>
              <p
                v-if="loginError"
                class="txtClrRed"
                style="margin:0px;padding-left:12px;text-align:center;"
              >
                {{ loginErrorMsg }}
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import JS from '../services/JsonService'
export default {
  components: {},
  data() {
    return {
      login: false,
      uName: '',
      uPswd: '',
      loginError: false,
      loginErrorMsg: ''
    }
  },
  created: function() {
    sessionStorage.clear()
    sessionStorage.setItem(
      'haveLogin',
      JSON.stringify({
        login: false
      })
    )
  },
  methods: {
    checkUserInput() {
      this.loginError = false
      if (this.uName == '' || this.uName == undefined) {
        this.loginError = true
        this.loginErrorMsg = 'User Name can not be empty!'
      } else {
        if (this.uPswd == '' || this.uPswd == undefined) {
          this.loginError = true
          this.loginErrorMsg = 'User Password can not be empty!'
        } else {
          this.loginError = false
          this.loginErrorMsg = ''
          this.doLogin()
        }
      }
    },
    doLogin() {
      // console.log(this.uName)
      // console.log(this.uPswd)
      const url = 'Account/Login'
      const parameter = {
        Version: 1,
        Username: this.uName,
        Password: this.uPswd
      }
      //console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          //console.log(response.data)
          if (response.data.UserID) {
            this.loginError = false
            this.loginErrorMsg = ''
            const key = 'MemberInfo'
            const value = JSON.stringify(response.data)
            sessionStorage.setItem(key, value)
            this.toAuthList()
          } else {
            this.loginError = true
            this.loginErrorMsg = response.data
          }
        })
        .catch(error => {
          //console.log(error)
          this.loginError = true
          this.loginErrorMsg = error
        })
    },
    toAuthList() {
      this.login = true
      sessionStorage.setItem(
        'haveLogin',
        JSON.stringify({
          login: this.login
        })
      )

      this.$router.replace('/authList')
    }
  }
}
</script>

<style>
.loginBtn {
  width: 80%;
  margin-bottom: 15px;
}
.txtClrRed {
  color: red;
}
</style>
